import { getToken, getCookieToken } from '@/utils/globalData'

export default defineNuxtRouteMiddleware((to, from) => {
  // 白名单路由（不需要登录的页面）
  const whiteList = [
    '/sub/login',
    '/sub/register', 
    '/sub/refindpsw',
    '/sub/order',
    '/sub/payment',
    '/',
    '/product',
    '/detail',
    '/shop',
    '/preview',
    '/payment',
    '/payment/successful',
    '/order/query',
    '/category',
    '/service',
    '/cart',
    '/v'
  ]

  // 检查当前路由是否在白名单中
  const isInWhiteList = whiteList.some(path => {
    if (path === '/') {
      return to.path === '/'
    }
    return to.path.startsWith(path)
  })

  // 如果在白名单中，直接放行
  if (isInWhiteList) {
    return
  }

  // 获取 token（客户端从 localStorage，服务端从 cookie）
  let token = null
  if (process.client) {
    token = getToken()
  } else if (process.server) {
    const headers = useRequestHeaders()
    token = getCookieToken(headers)
  }

  // 如果没有 token，重定向到登录页
  if (!token) {
    console.log('=== Auth Middleware: No token found ===')
    console.log('Current path:', to.fullPath)
    console.log('Redirecting to: /sub/login')
    
    return navigateTo({
      path: '/sub/login',
      query: {
        redirect: to.fullPath // 保存原来要去的地址，登录后可以跳回
      }
    })
  }
})
